// The suite now boots through e2e-host's binary, which serves `/__config`
// and style-profile's own API mocks from a single shared port (ADR-2.4). A
// workspace subpath re-export of
// `@lookiero/e2e-host/src/testVariant/mockServerPort` would require
// style-profile to declare a runtime dependency on the host, creating the
// exact build-order cycle ADR-3 avoids via type-only imports — so the value
// is kept in sync by hand. Drift here fails loudly (the host's `/__config`
// fetch times out against the wrong port), never silently.
const MOCK_SERVER_PORT = 3012;

export { MOCK_SERVER_PORT };
